module.exports = __webpack_public_path__ + "static/media/transformation_img.85d6357b.jpg";